<template>
  <div>
    <v-tabs
      color="secondary"
      v-model="tab"
      :height="40"
      grow
      :mobile-break-point="300"
      class="ma-3"
      icons-and-text
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab
        v-if="showClinicTab || user.mainType == 0 || user.mainType == 1"
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        {{ $t('Engenharia clinica') }}
        <img
          src="../../../../assets/figmaIcons/green/reports.svg"
          alt="Equip"
          style="object-fit: contain"
          class="ma-1 mr-2"
        />
      </v-tab>

      <v-tab
        v-if="showInfraTab || user.mainType == 0 || user.mainType == 1"
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        {{ $t('Engenharia de infraestrutura') }}
        <img
          src="../../../../assets/figmaIcons/green/reports.svg"
          alt="Equip"
          style="object-fit: contain"
          class="ma-1 mr-2"
        />
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-if="showClinicTab || user.mainType < 2">
        <PopsEngClinic ref="clinic" />
      </v-tab-item>
      <v-tab-item v-if="showInfraTab || user.mainType < 2">
        <PopsEngInfra ref="infra" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import PopsEngClinic from './PopsEngClinic.vue'
import PopsEngInfra from './PopsEngInfra.vue'

export default {
  name: 'PopsTabs',

  components: {
    PopsEngClinic,
    PopsEngInfra,
  },

  data() {
    return {
      tab: 0,
      user: {},
      institution: {},
    }
  },

  computed: {
    showClinicTab() {
      const types = this.institution?.departmentTypes || []
      return (this.institution?.showEngClinic || this.institution?.showEngInfra) && types.includes(0)
    },
    showInfraTab() {
      const types = this.institution?.departmentTypes || []
      return (this.institution?.showEngClinic || this.institution?.showEngInfra) && types.includes(1)
    },
  },

  watch: {
    tab() {
      if (this.$refs.clinic) {
        this.$refs.clinic.loadData?.()
      } else if (this.$refs.infra) {
        this.$refs.infra.loadData?.()
      }
    },
  },

  created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institution = institution

    const user = JSON.parse(localStorage.getItem('user'))
    this.user = user
  },
}
</script>
